<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">加入购物车</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">

                <el-form :model="addOrderForm" :rules="rules" ref="addOrderForm">
                    <div>
                        <el-row>
                            <el-col :span="24" class="item">
                                <el-form-item label="输入商品数量" required prop="number">
                                    <el-input v-model.number="addOrderForm.number" placeholder="请输入商品数量"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" class="item">
                                <el-form-item label="选择预约时间" required prop="planTime">
                                  <el-date-picker
                                      v-model="addOrderForm.planTime"
                                      type="datetime"
                                      style="width:100%;"
                                      value-format="yyyy-MM-dd HH:mm"
                                      placeholder="选择预约时间">
                                  </el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addOrderForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: 'Add',
        data() {
            return {

                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },

                loading: false,

                addOrderForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    elderlyCode:'',
                    number:1,
                    planTime:'',
                    goodsCode:'',
                  goodsAttributeCodesArg:[],
                  goodsAttributeCodesValueArg:[],
                },

                rules:{
                    planTime:[
                        { required: true, message: '请选择预约时间', trigger: 'blur' },
                    ],
                    number:[
                        { required: true, message: '请输入商品数量', trigger: 'blur' },
                        { type: 'number', message: '商品数量为数字值'}
                    ],
                },

            }
        },

        methods: {
            init(row,elderlyCode){
                this.$refs.addOrderForm.resetFields();
                this.addOrderForm.elderlyCode=elderlyCode
                this.addOrderForm.goodsCode=row.goodsCode
            },
            closeSelf() {
                this.$emit("closeAddOrder");
            },

            confirm(addOrderForm){
                this.$refs[addOrderForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        this.$message({type: 'info', message: '请完善信息'});
                        return false;
                    }
                })
            },
            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.addOrderForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"AppCare/BeforeCartAdd",
                    data: this.addOrderForm
                }).then((response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                          this.$emit("closeAddOrder");
                          this.$emit("getCart2");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    })
            },


        }
    }

</script>
